import React, {useState, useEffect} from "react";
import {VsiBubble, VsiH4 } from "../../../../styled/App.styled";
import {useSearchParams} from "react-router-dom";
import {useVsiAppContext} from "../../../../stores/VsiApp";
import {useDataWithRoute, useTitleFromComponent} from "../../../../utils/hooks";
import {Card} from "reactstrap";
import AtAGlance from "../../../../components/AtAGlance";
import Grid from "../../../../components/Grid";
import Stockchart from "../../../../components/Stockchart";
import {formatStockChartConfig} from "../../../../utils/Helpers";
import { enterpriseTrendColors } from "../../../../utils/chartUtils";
import {integerFormatter, numberFormatter} from "../../../../utils/gridFormatters";

const auditReportRowAag = [
    {
        field: "device_name",
        mobile: true,
    },
    {
        field: "model",
        mobile: true,
    },
    {
        field: "vendor",
        mobile: true,
    },
    {
        field: "classification",
        // icon: true,
        // diff: true,
        mobile: true,
    },
    {
        field: "data_center",
        // icon: true,
        // diff: true,
        mobile: true,

    },
    {
        field: "geography",
        // icon: true,
        // diff: true,
        mobile: true,

    },
    {
        field: "application",
        // icon: true,
        // diff: true,
        mobile: true,

    },
    {
        field: "virtualized",
        // icon: true,
        // diff: true,
        mobile: true,

    },
    {
        field: "firmware_level",
        // icon: true,
        // diff: true,
        mobile: true,

    },
    {
        field: "end_of_maintenance_date",
        // icon: true,
        // diff: true,
        mobile: true,

    },
    {
        field: "end_of_life_date",
        // icon: true,
        // diff: true,
        // mobile: true,

    },
];

const auditReportColAag = [
    {
        field: "array_status",
        mobile: true,
    },
    {
        field: "iops",
        title: "IOPS",
        mobile: true,
    },
    {
        field: "avg_latency",
        mobile: true,
    },
    {
        field: "red",
        mobile: true,
    },
    {
        field: "yellow",
        mobile: true,
    },
    {
        field: "green",
        mobile: true,
    },
    {
        field: "total_used",
        mobile: true,
    },
    {
        field: "pct_used",
        title: "% Used",
        mobile: true,
    },
    {
        field: "pct_allocated",
        title: "% Allocated",
        mobile: true,
    },
    {
        field: "weeks_left_to_80_pct",
        title: "Weeks to 80%",
        ignoreSuffix: true,
        mobile: true,
    },
    {
        field: "weeks_left_to_100_pct",
        title: "Weeks to 100%",
        ignoreSuffix: true,
        mobile: true,
    },
    {
        field: "data_reduction_ratio",
        mobile: true,
    },
    {
        field: "weighted_monthly_growth_rate",
        mobile: true,
    },
];

const auditReportGridDefs = [
    {
        "field": "host_name",
        "headerName": "Host Name",
        "enableValue": true,
        // "type": "numericColumn",
        "enableRowGroup": true
    },
    {
        "field": "total_allocated",
        "headerName": "Total Allocated",
        "enableValue": true,
        "type": "numericColumn",
        "enableRowGroup": true,
        "cellRenderer": integerFormatter
    },
    {
        "field": "total_free",
        "headerName": "Total Free",
        "enableValue": true,
        "type": "numericColumn",
        "enableRowGroup": true,
        "cellRenderer": numberFormatter
    },
];

const auditReportBuGridDefs = [
    {
        "field": "business_unit",
        "headerName": "Business Unit",
        "enableValue": true,
        // "type": "numericColumn",
        "enableRowGroup": true
    },
];

export default function AuditReport({context, title}) {

    const [searchParams] = useSearchParams();
    const { theme, client, periodId } = useVsiAppContext();

    const [aagData, setAagData] = useState({});
    const [chartData, setChartData] = useState([]);
    const [chartCategories, setChartCategories] = useState([]);
    const [gridData, setGridData] = useState([]);
    const [buData, setBuData] = useState([]);

    useTitleFromComponent(`${searchParams.get('device_name')} / ${title}`);

    const [deviceHistory] = useDataWithRoute(`/api/v6/report/device_capacity_history_proc?client_id=${client?.clientId}&device_name=${encodeURIComponent(searchParams.get('device_name'))}&period_id=${periodId}`)
    const [deviceAag] = useDataWithRoute(`/api/v6/report/device_audit_proc?client_id=${client.clientId}&period_id=${periodId}&device_name=${encodeURIComponent(searchParams.get('device_name'))}`)

    useEffect(() => {
        setAagData(deviceAag?.recordset?.[0] ?? {});
        setGridData(deviceAag?.recordsets?.[1]);
        setBuData(deviceAag?.recordsets?.[2]);
    }, [deviceAag]);

    useEffect(() => {
        const trendConfig = formatStockChartConfig(deviceHistory?.recordset ?? [],
            [{
                name: 'Free',
                field: 'total_free',
            }, {
                name: 'Used',
                field: 'total_used',
            }, {
                name: 'Allocated',
                field: 'total_allocated',
            }, {
                name: 'Capacity',
                field: 'usable_gb',
            }, {
                name: 'Orphaned',
                field: 'orphan_gb',
            }]
        );
        setChartData(trendConfig.series);
        setChartCategories(trendConfig.categories);
    }, [deviceHistory])

    return <Card className={`report-card p-2 nav-card-${theme}`}>
        <VsiH4>Audit Report - {searchParams.get('device_name')}</VsiH4>
        <VsiBubble className={`mb-2 p-2`} autobotInfo={{ data: {
                aag1: { data: aagData, config: auditReportRowAag },
                aag2: { data: aagData, config: auditReportColAag }
            } }}>
            <AtAGlance config={auditReportRowAag} data={aagData} size={"lg"}/>
        </VsiBubble>
        <VsiBubble>
            <Stockchart categories={chartCategories} series={chartData} config={{
                yAxis: {
                    title: {
                        text: 'GiB'
                    },
                },
                colors: enterpriseTrendColors,
            }}/>
        </VsiBubble>
        <VsiBubble className={`my-2 p-2`} autobotInfo={{ data: {
                aag1: { data: aagData, config: auditReportRowAag },
                aag2: { data: aagData, config: auditReportColAag }
            } }}>
            <AtAGlance config={auditReportColAag} data={aagData} size={"lg"}/>
        </VsiBubble>
        <VsiBubble>
            <Grid addStyle data={buData} columnDefs={auditReportBuGridDefs}/>
        </VsiBubble>
    </Card>
}
